/**
 * French typography: a no-break space before ! ? : € and inside « »,
 * and a narrow one before %, so a line never starts with punctuation or a
 * currency sign. (`Words` splits on regular spaces only, so these stay
 * glued.)
 */
export const frTypo = (text: string) =>
  text
    .replace(/ ([!?:€»])/g, "\u00A0$1")
    .replace(/« /g, "«\u00A0")
    .replace(/ %/g, "\u202F%");

/** Apply `frTypo` to every string of a copy object (functions untouched). */
export const mapStrings = <T,>(value: T): T => {
  if (typeof value === "string") return frTypo(value) as T;
  if (Array.isArray(value)) return value.map(mapStrings) as T;
  if (typeof value !== "object" || value === null) return value;
  const out: Record<string, unknown> = {};
  for (const key of Object.keys(value)) {
    const v = (value as Record<string, unknown>)[key];
    out[key] = typeof v === "function" ? v : mapStrings(v);
  }
  return out as T;
};
